import React from 'react'
import { connect } from 'react-redux'
import { FileDrop } from 'react-file-drop'
import Elevation from '../../../../../lib/api/elevation'
import { collapseLeftToolbar as collapseLeftToolbarAction } from '../../../../../action/left-toolbar-state-actions'
import {
  photoCreateRequest,
  photoUploadRequest,
  photoUpdateRequest,
  photoDeleteRequest as photoDeleteAction
} from '../../../../../action/photo-actions'
// import Lock from '@material-ui/icons/Lock'
// import LockOpen from '@material-ui/icons/LockOpen'
import Lock from '@mui/icons-material/Lock';
import LockOpen from '@mui/icons-material/LockOpen';
import isNil from 'lodash/isNil'
import { blockFeatures, unBlockFeatures } from '../../../../../action/features-blocked-actions'
import { enableMapObject, disableMapObject } from '../../../../../action/disable-map-obj-state-action'
import ConfirmRemoval from '../confirm-removal'
import DragAndDropImage from './dragAndDropImage'
import CameraIcon from '../../../../../../asset/cameraIcon.png'
import './photo.css'
import { ColorCodes } from '../marker-details/dummy'
import ImageViewModel from './imageView'
import { weatherUpdate } from '../../../../../action/weather-action'
import DiscardChanges from '../marker-details/discard-changes'
import { decimalToDMS, decimalToUTM, decimalToUTMParts, dateConvertion } from '../../../../main-ui/common/commonfunctions'
import { renderInfoBox } from '../../../../map/render-photos/listner'
import { throttle } from '../reusable-function'

class PhotoDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      altitude: 0,
      latitude: '',
      longitude: '',
      name: `Photo - ${props.photos.length}`,
      notes: '',
      locationSet: true,
      imageUrl: 'https://lh3.googleusercontent.com/xJLZGP5kpd5IcYjgoGFnSGu7h6YmtBBd_wGhEbOsRlQssIpIpGdxFAbpzPj844bBGqeC4gsoyGuzVBr9tAObaHFh=s1600-w1600-h1000',
      thumbnailUrl: null,
      confirmRemoval: false,
      colorMarker: 'red',
      isImageUploaded: true,
      imageFile: '',
      imageBgColor: '9ECC3B',
      unMountComponent: true,
      imageViewModel: false,
      discardPopUp: false,
      loadSpinner: false,
    }
    this.marker = null
    this.latitude = null
    this.longitude = null
    this.clickListener = null
    this.moveListener = null
    this.fileInput = React.createRef()
    this.latitudeRef = React.createRef()
    this.longitudeRef = React.createRef()
    this.inputEle = React.createRef()
    this.advanceMarker = null
    this.HandleSetPhoto = this.setPhoto.bind(this);
    this.savePhoto = throttle(this.savePhoto.bind(this), 15000); // Throttle for 2 seconds
    this.moveHandler = null
  }

  componentDidMount() {
    const { editable, mapObj } = this.props.leftToolbarState
    if (editable) {
      const photoDetails = Object.assign(this.state, editable)
      this.setState({ photoDetails, isImageUploaded: false, imageBgColor: photoDetails.color == "669900" ? "589500" : photoDetails.color }, () => {
        this.advanceMarker = photoDetails.mapObj()
        this.latitude = photoDetails.latitude.toFixed(6)
        this.longitude = photoDetails.longitude.toFixed(6)
      })
    } else {
      const { mapReference, disableMapObject } = this.props
      // disableMapObject()
    }
  }

  buildContent = (url, color) => {
    let bgColor
    if (color) {
      if (color.length <= 6 || color.length <= 7) {
        bgColor = color[0] == '#' ? color : '#' + color
      } else {
        bgColor = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
      }
    } else {
      bgColor = '9ECC3B'
    }
    const content = document.createElement("div");
    content.classList.add("photo-property");
    content.innerHTML = `
    <div style="height: 30px; width: 30px; border: 2px solid ${bgColor[0] == '#' ? bgColor : '#' + bgColor}; border-radius: 50%; overflow: hidden; margin-bottom: 5px; position: relative;background-color: ${bgColor}">
    <img style="height: 30px; width: 30px; object-fit: cover; position: absolute; top: 0; left: 0;" src="${url ? url : 'https://images.unsplash.com/photo-1575936123452-b67c3203c357?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D'}" alt="Image">
    </div>
    <div class="triangle-style-mouse-handler" style="border-top: 13px solid ${bgColor[0] == '#' ? bgColor : '#' + bgColor}" ></div>
    `
    return content;
  }

  componentDidUpdate(prevProps, prevState) {
    const { editable } = this.props.leftToolbarState,
      prevEditable = prevProps.leftToolbarState.editable
    if (editable && prevEditable.id !== editable.id) {
      const photoDetails = Object.assign(this.state, editable)
      this.setState({ photoDetails, imageBgColor: photoDetails.color }, () => {
        this.marker = editable.mapObj()
        this.advanceMarker = editable.mapObj()
        this.latitude = photoDetails.latitude
        this.longitude = photoDetails.longitude
      })
    }
    if (prevState.isImageUploaded !== this.state.isImageUploaded) {
    }
  }

  componentWillUnmount() {
    const { photo, mapObj, mapReference, infoWindow, auth } = this.props
    let openInfoWindowClose = null
    let token = auth.token
    this.removeMouseHandlers()
    if (!this.props.leftToolbarState.editable && this.advanceMarker) {
      this.advanceMarker.map = null;
    } else if (this.props.leftToolbarState.editable && this.state.unMountComponent) {
      if (this.advanceMarker) {
        this.advanceMarker.position = {
          lat: this.props.leftToolbarState.editable.latitude,
          lng: this.props.leftToolbarState.editable.longitude
        };
        this.advanceMarker.content = this.buildContent(
          this.props.leftToolbarState.editable.imageUrl,
          this.props.leftToolbarState.editable.color
        );
        let photo = this.props.leftToolbarState.editable
        this.advanceMarker.addListener('gmp-click', () => renderInfoBox(mapReference, this.props.leftToolbarState.mapObj, photo, infoWindow, openInfoWindowClose, token, "Photo"))
        this.props.mapReference.setCenter({
          lat: this.props.leftToolbarState.editable.latitude,
          lng: this.props.leftToolbarState.editable.longitude
        })
      }
    } else if (!this.props.leftToolbarState.editable) {
      if (this.advanceMarker) { this.advanceMarker.map = null; }
    } else {
      this.advanceMarker.map = null;
    }
    this.props.enableMapObject()
  }

  async setPhoto(e) {
    this.setState({ imageFile: e, isImageUploaded: false, imageViewModel: false })
    const file = e;
    if (file) {
      const url = URL.createObjectURL(file);
      const { mapReference } = this.props;
      const createMarkerFunction = async () => {
        let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        const markerOptions = {
          map: mapReference,
          position: mapReference.getCenter(),
          gmpClickable: true,
        };
        this.advanceMarker = new AdvancedMarkerElement(markerOptions)
      }
      await createMarkerFunction()
      // Mouse move Handler
      this.addMouseHandlers()
      // setting state values and updating image on the marker
      this.setState({
        thumbnailUrl: url,
        imageUrl: url,
        photoFile: file,
        imageViewModel: false,
        locationSet: false
      }, () => {
        this.advanceMarker.content = this.buildContent(this.state.imageUrl, this.state.imageBgColor);
      })
    }
  }

  handleImageView() {
    this.setState({ isImageUploaded: false })
  }

  savePhoto() {
    const { photoCreateRequest, photoUpdateRequest, leftToolbarState, collapseLeftToolbar, user } = this.props,
      { name, notes, latitude, longitude, altitude, photoFile, thumbnailUrl, imageUrl, imageBgColor } = this.state,
      photoInfo = {
        color: imageBgColor,
        name,
        typeId: 1,
        notes,
        latitude,
        longitude,
        altitude
      },
      data = new FormData(),
      infoString = JSON.stringify(photoInfo)
    data.append('photo', photoFile)
    data.append('photoInfo', infoString)
    this.setState({ loadSpinner: true })
    if (leftToolbarState.editable) {
      //update
      photoInfo['thumbnailUrl'] = thumbnailUrl
      photoInfo['imageUrl'] = imageUrl
      photoInfo['userId'] = user.id
      photoInfo['id'] = leftToolbarState.editable.id

      const handlePhotoUpdateRequest = async () => {
        try {
          const res = await photoUpdateRequest(photoInfo)
          this.setState({ unMountComponent: false, imageViewModel: false })
          if (res) {
            this.setState({ loadSpinner: false })
          }
          collapseLeftToolbar()
        } catch (error) {
          console.log('Photo Update Failed', error)
        }
      }
      handlePhotoUpdateRequest()
    } else {
      //create
      const handlePhotoCreateRequest = async () => {
        try {
          const res = await photoCreateRequest(data)
          collapseLeftToolbar()
          if (res) {
            this.setState({ loadSpinner: false })
          }
        } catch (error) {
          console.error('Photo Creation Failed', error)
        }
      }
      handlePhotoCreateRequest()
    }
  }

  addMouseHandlers() {
    const { mapReference, token, blockFeatures, disableMapObject, disableMapObj, weatherUpdate, enableMapObject } = this.props
    blockFeatures()
    mapReference.setOptions({ draggableCursor: 'crosshair' })
    if (disableMapObj) {
      disableMapObject()
    }
    else {
      // enableMapObject()
      disableMapObject()
    }
    // this.marker.clickable = false
    // this.setState({ locationSet: false })

    // this.moveListener = mapReference.addListener('mousemove', (e) => {
    //   const lat = Math.round(e.latLng.lat() * 1000000) / 1000000,
    //     lng = Math.round(e.latLng.lng() * 1000000) / 1000000
    //   if (this.latitudeRef.current && this.longitudeRef.current) {
    //     this.latitudeRef.current.value = lat
    //     this.longitudeRef.current.value = lng
    //   }
    //   // this.marker.setPosition(e.latLng)
    //   this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
    // })

    this.moveHandler = (e) => {
      const lat = Math.round(e.latLng.lat() * 1000000) / 1000000;
      const lng = Math.round(e.latLng.lng() * 1000000) / 1000000;

      if (this.latitudeRef.current && this.longitudeRef.current) {
        this.latitudeRef.current.value = lat.toFixed(6);
        this.longitudeRef.current.value = lng.toFixed(6);
        this.latitude = lat.toFixed(6)
        this.longitude = lng.toFixed(6)
      }
      this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    };

    // Add the mousemove event listener using the function reference
    this.moveListener = mapReference.addListener('mousemove', this.moveHandler);
    this.clickListener = google.maps.event.addListenerOnce(mapReference, 'click', (e) => {
      const lat = Math.round(e.latLng.lat() * 1000000) / 1000000,
        lng = Math.round(e.latLng.lng() * 1000000) / 1000000
      if (this.latitudeRef.current && this.longitudeRef.current) {
        this.latitudeRef.current.value = lat.toFixed(6)
        this.longitudeRef.current.value = lng.toFixed(6)
        this.latitude = lat.toFixed(6)
        this.longitude = lng.toFixed(6)
        this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
        // weatherUpdate({ lat: this.latitude, lng: this.longitude })
      }
      Elevation.getElevation(lat, lng, token)
        .then(res => {
          this.setState({ altitude: res })
        })
        .catch(() => {
          console.error('Unable to get photo altitude for:', lat, lng)
        })
      this.setState({ latitude: lat, longitude: lng, locationSet: true })
      // this.marker.setPosition(e.latLng)
      this.advanceMarker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() }
      //
      this.removeMouseHandlers()
      // this.moveListener = null;
    })
  }

  removeMouseHandlers() {
    const { mapReference, unBlockFeatures, disableMapObj, enableMapObject } = this.props
    if (disableMapObj) {
      enableMapObject()
    }
    else {
      enableMapObject()
    }
    if (this.clickListener !== null) {
      google.maps.event.removeListener(this.clickListener)
      this.clickListener = null
    }
    // if (this.moveListener !== null) {

    //   console.log('this.moveListener====================>', this.moveListener)
    //   // this.moveListener.remove()
    //   google.maps.event.removeListener(this.moveListener);
    //   this.moveListener = null
    // }
    // Remove the mousemove event listener using the function reference
    if (this.moveListener !== null && this.moveListener !== undefined) {
      google.maps.event.removeListener(this.moveListener, this.moveHandler);
      this.moveListener = null;
    }


    mapReference.setOptions({ draggableCursor: 'grab' })
    unBlockFeatures()
  }

  handleImageViewModel() {
    this.setState({ imageViewModel: !this.state.imageViewModel })
  }

  makeUTMInputs() {
    const lat = parseFloat(this.state.latitude)
    const lng = parseFloat(this.state.longitude)
    if (isNaN(lat) || isNaN(lng)) return null
    const { zone, eastingM, northingM, hemisphere } = decimalToUTMParts(lat, lng)
    const inputStyle = {
      background: '#333333',
      color: 'white',
      marginTop: '5px',
      width: '100%',
      height: 40,
      border: 'none',
      borderRadius: 5,
      padding: '0 10px',
      boxSizing: 'border-box',
    }
    const badgeStyle = {
      display: 'inline-block',
      background: '#3a3a3a',
      color: '#aaa',
      fontSize: '11px',
      padding: '3px 8px',
      borderRadius: 4,
    }
    return (
      <div style={{ marginBottom: '10px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{ flex: '0 0 100px' }}>
            <label className='label-style' style={{ fontSize: '12px' }}>Zone:</label>
            <div style={{ display: 'flex', alignItems: 'center', background: '#333333', borderRadius: 5, marginTop: '5px', height: 40 }}>
              <input type='text' readOnly value={zone} style={{ ...inputStyle, marginTop: 0, background: 'transparent', flex: 1, minWidth: 0 }} />
              <span style={{ paddingRight: '10px', fontSize: '13px', color: '#888', flexShrink: 0 }}>&#128274;</span>
            </div>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <label className='label-style' style={{ fontSize: '12px' }}>Easting (m):</label>
            <input type='text' readOnly value={eastingM.toLocaleString('en-US')} style={{ ...inputStyle, width: '100%' }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <label className='label-style' style={{ fontSize: '12px' }}>Northing (m):</label>
            <input type='text' readOnly value={northingM.toLocaleString('en-US')} style={{ ...inputStyle, width: '100%' }} />
          </div>
        </div>
        <p style={{ fontSize: '11px', color: '#777', margin: '4px 0 6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
          &#9432; Zone auto-set from coords &middot; tap lock to override
        </p>
        <div style={{ display: 'flex', gap: '8px' }}>
          <span style={badgeStyle}>Datum: WGS84</span>
          <span style={badgeStyle}>Hemisphere: {hemisphere}</span>
        </div>
      </div>
    )
  }

  makeTextInput(properties) {
    const { name, width, access, marginLeft } = properties
    let heloValue = !isNil(properties.displayVal) && properties.displayVal && properties.displayVal.length > 2 ? properties.displayVal : this.state[name]
    let dmsValue = heloValue && (name === 'latitude' || name === 'longitude') && decimalToDMS(heloValue, name === 'latitude')
    let utmValue = name === 'latitude' ? decimalToUTM(this.state.latitude, this.state.longitude) : ''
    let usageValue = () => {
      if (name == 'latitude' || name === 'longitude') {
        if (this.props.userPreferences.coordinates == "dms") {
          return dmsValue
        } else if (this.props.userPreferences.coordinates == "utm") {
          return utmValue
        } else {
          return heloValue
        }
      } else {
        return heloValue
      }
    }
    return (
      <div style={{ width, height: 68, marginTop: 10, marginLeft }} key={`markerInput-${properties.name}`}>
        <label htmlFor={name}
          className='label-style'
          style={{
            fontSize: '12px',
            textTransform: 'capitalize'
          }}>{`${name}:`}</label>
        <input type='text'
          name={name}
          id={name}
          style={{
            background: '#333333 0% 0% no-repeat padding-box',
            opacity: 1,
            marginTop: '5px',
            width: access ? '99.5%' : '84%',
            height: 40,
            border: 'none',
            borderRadius: 5,
            padding: '0 10px',
          }}
          placeholder={name}
          readOnly={(name == 'latitude' || name === 'longitude') && (this.props.userPreferences.coordinates == 'dms' || this.props.userPreferences.coordinates == 'utm')}
          ref={name === 'latitude' ? this.latitudeRef : name === 'longitude' ? this.longitudeRef : null}
          onChange={this.props.userPreferences != 'dns' && this.handleInputChange.bind(this)}
          value={usageValue()}
        />
      </div>
    )
  }

  onChange(e) {
    const { target } = e
    if (target.name === 'latitude') {
      this.latitude = target.value
      const newPos = { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) }
      // const newPos = new google.maps.LatLng(parseFloat(this.latitude), parseFloat(this.longitude))
      // this.marker.setPosition(newPos)
      this.advanceMarker.position = newPos
    }
    if (target.name === 'longitude') {
      this.longitude = target.value
      const newPos = { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) }
      // const newPos = new google.maps.LatLng(parseFloat(this.latitude), parseFloat(this.longitude))
      // this.marker.setPosition(newPos)
      this.advanceMarker.position = newPos
    }
    this.setState({ [target.name]: target.value })
  }

  handleInputChange = (e) => {
    const { target } = e;
    let { name, value } = target;
    let newPos
    const regex = /^-?\d*\.?\d{0,6}$/;
    if (!regex.test(value)) {
      if (name === 'latitude' || name === 'longitude')
        return;
    }
    if (name === 'latitude') {
      if (value.length > 1) {
        this.latitude = parseFloat(value);
      }
    }

    if (name === 'longitude') {
      if (value.length > 1) {
        this.longitude = parseFloat(value);
      }
    }

    newPos = { lat: isNaN(this.latitude) ? 0 : parseFloat(this.latitude), lng: isNaN(this.longitude) ? 0 : parseFloat(this.longitude) };
    this.props.mapReference.setCenter(newPos)
    name != 'name' && this.props.mapReference.setZoom(14)
    this.advanceMarker.position = newPos;
    this.setState({ [name]: value });
  };

  async removePhoto() {
    const { photoDeleteRequest, leftToolbarState, collapseLeftToolbar } = this.props,
      { editable } = leftToolbarState
    try {
      let res = await photoDeleteRequest(editable.id);
      this.advanceMarker.map = null
      collapseLeftToolbar()
    } catch (error) {
      console.log('Photo deletion failed', error)
    }
  }

  cancelRemoval() {
    this.setState({ confirmRemoval: false, imageViewModel: false })
  }

  photoMarkerIcon(color, isEditable) {
    const { editable, mapObj } = this.props.leftToolbarState
    let bgColor
    if (color && color.length > 1) {
      if (color.length <= 6 || color.length <= 7) {
        bgColor = color[0] == '#' ? color : '#' + color
      }
      else {
        bgColor = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
      }
    } else {
      bgColor = '9ECC3B'
    }
    const selectColor = (value) => {
      this.setState({ imageBgColor: value, imageViewModel: false })
      this.advanceMarker.content = this.buildContent(this.state.imageUrl, value)
    }

    let onEditImage = (e) => {
      const file = e.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        this.setState({
          thumbnailUrl: imageUrl,
          imageUrl: imageUrl,
          imageFile: file,
          imageViewModel: false,
          locationSet: false,
          isImageUploaded: false,
          photoFile: file
        }, () => {
          this.advanceMarker.content = this.buildContent(this.state.imageUrl, this.state.imageBgColor)
        })
      }
    }

    return (
      <div className='image-color-change '>
        <label
          className='label-style'
          style={{
            fontSize: '14px',
            textTransform: 'capitalize'
          }}>Style:</label>
        <div style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {!editable && <div style={{ width: '100%', textAlign: 'right' }}>
            <p
              style={{ textDecoration: 'underline', cursor: 'pointer', userSelect: 'none' }}
              onClick={() => this.inputEle.current.click()}
            >
              Change Image
            </p>
            <input
              type='file'
              accept='image/*,.png'
              ref={this.inputEle}
              style={{ display: 'none' }}
              onChange={onEditImage}
            ></input>
          </div>}
          <div
            className='file-drop-target-image'
            style={{ border: `5px solid ${bgColor[0] == '#' ? bgColor : '#' + bgColor}`, }}>
            <a>
              <img className='upload-image-icon-style'
                onClick={() => { this.handleImageViewModel() }}
                src={isEditable ? this.state.imageUrl : this.state.imageFile && URL.createObjectURL(this.state.imageFile)}
              >
              </img>
            </a>
          </div>
          <div className='select-color-container' style={{ display: 'flex', flexWrap: 'wrap', height: '90px', width: '96%', marginLeft: '6px', marginRight: '6px' }}>
            {ColorCodes.map((item, index) => {
              return (
                <div key={index} style={{ width: 'calc(14.28% - 10px)', height: '40px', margin: '5px' }}>
                  <a onClick={() => selectColor(item)}>
                    <div style={{ width: '30px', height: '20px', borderRadius: '5px', backgroundColor: '#' + item }}></div>
                  </a>
                  <div className={item === this.state.imageBgColor ? 'bottom-box' : ''} ></div>
                </div>
              );
            })}
          </div>
        </div>
      </div >
    )
  }

  jsonObjectFunction = (editable) => {
    if (editable) {
      if (typeof (editable.weatherObservation) == 'object') {
        let temp = editable.weatherObservation.weatherObservation.tempF
        let iconUrl = editable.weatherObservation.weatherObservation.baseIconUrl + editable.weatherObservation.weatherObservation.weatherIcon
        let weatherPrimary = editable.weatherObservation.weatherObservation.weatherPrimary
        return { temparature: temp, iconUrl: iconUrl, weatherPrimary: weatherPrimary }
      } else if (typeof (editable.weatherObservation) == 'string') {
        let jasonData = JSON.parse(editable.weatherObservation);
        let temp = jasonData.WeatherObservation.TempF
        let iconUrl = jasonData.WeatherObservation.BaseIconUrl + jasonData.WeatherObservation.WeatherIcon
        let weatherPrimary = jasonData.WeatherObservation.WeatherPrimary
        return { temparature: temp, iconUrl: iconUrl, weatherPrimary: weatherPrimary }
      }
    } else {
      return null
    }
  }

  handleCancelButton = (editable) => {
    if (editable) {
      const normalizedColor = editable.color == "669900" ? "589500" : editable.color
      const hasChanges = (
        this.state.name != editable.name ||
        (this.state.notes || '') != (editable.notes || '') ||
        this.state.imageBgColor != normalizedColor ||
        this.state.latitude != editable.latitude ||
        this.state.longitude != editable.longitude
      )
      if (hasChanges) {
        this.setState({ discardPopUp: true })
      } else {
        this.props.collapseLeftToolbar()
        this.props.enableMapObject()
      }
    } else {
      this.props.collapseLeftToolbar()
      this.props.enableMapObject()
    }
  }

  closePopUp() {
    this.setState({ discardPopUp: false })
  }

  discardChange(editable) {
    if (editable) {
      this.advanceMarker.position = { lat: parseFloat(editable.latitude), lng: parseFloat(editable.longitude) }
      this.advanceMarker.content = this.buildContent(
        editable.imageUrl,
        editable.color
      );
    }
    this.props.collapseLeftToolbar()
    this.props.enableMapObject()
  }


  render() {
    const { leftToolbarState, collapseLeftToolbar, photoDeleteRequest, userPreferences } = this.props,
      { editable } = leftToolbarState,
      { locationSet, imageUrl, imageBgColor, loadSpinner } = this.state,
      iconStyles = {
        fontSize: '24px',
        height: '24px',
        position: 'relative',
        top: '5px',
        float: 'right',
        overflowY: 'scroll'
      },
      height = `calc(100vh - ${editable ? '355px' : '525px'})`,
      contentHeight = `calc(100vh - ${editable ? '75px' : '250px'})`,
      hasCoords = this.state.latitude && this.state.longitude ? true : false,
      backgroundColor = loadSpinner
        ? 'grey'
        : hasCoords
          ? '#589500'
          : 'grey';

    let jsonObject = editable && this.jsonObjectFunction(editable)
    let createdDate = dateConvertion(editable && editable.created)
    let updatedDate = dateConvertion(editable && editable.updated)

    return (
      <div className='tools-content' style={{
        boxSizing: 'border-box',
        height: contentHeight,
        height: "100%"
      }}>
        {loadSpinner && <div className='markers-load-spinner'>
          <div className="loader-spinner"></div>
        </div>}
        <div className='tools-header ' style={{ display: 'flex', justifyContent: "space-evenly" }}>
          <div className='camera-icon-border'>
            <img src={CameraIcon}></img>
          </div>
          <div style={{ width: "66%" }}> <h3 className='heading-bar'>{editable ? 'Photo Details' : 'Add Photo'}</h3></div>
          {!this.state.isImageUploaded ?
            locationSet ? <Lock
              onClick={() => {
                if (imageUrl) {
                  this.setState({ locationSet: false, imageViewModel: false }, () => {
                    this.addMouseHandlers()
                  })
                }
              }}
              style={iconStyles} /> : <LockOpen
              onClick={() => {
                this.setState({ locationSet: true, imageViewModel: false }, () => {
                  this.removeMouseHandlers()
                })
              }}
              style={iconStyles} />

            : ''
          }
        </div>

        <div style={{ width: '100%' }}>
          {!this.state.imageUrl ? (
            <></>
          ) : (
            !editable && this.state.isImageUploaded && <DragAndDropImage setPhoto={this.HandleSetPhoto}></DragAndDropImage>
          )}
        </div >
        {!this.state.isImageUploaded && <>
          <div style={{
            minHeight: '215px',
            height,
            boxSizing: 'border-box',
            width: '100%',
            padding: '1px',
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '5px'
          }}>

            <div style={{ width: '100%' }}>
              {!this.state.imageUrl ? (
                <></>
              ) : (
                !editable && this.state.isImageUploaded && <DragAndDropImage setPhoto={this.HandleSetPhoto}></DragAndDropImage>
              )}
            </div >
            {editable && <div>
              <h5>Created&nbsp;:&nbsp;&nbsp;{createdDate}</h5>
            </div>}
            {editable && updatedDate && <div style={{ marginTop: '10px' }}>
              <h5>Updated&nbsp;:&nbsp;&nbsp;{updatedDate}</h5>
            </div>}
            {this.makeTextInput({ name: 'name', width: '93%', access: true })}
            {this.props.userPreferences.coordinates === 'utm'
              ? this.makeUTMInputs()
              : <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                  {[
                    this.makeTextInput({ name: 'latitude', width: '45%', displayVal: this.latitude }),
                    this.makeTextInput({ name: 'longitude', width: '45%', displayVal: this.longitude })
                  ]}
                </div>
            }
            <div style={{ heigh: '160px', width: '100%', marginBottom: '15px' }}>
              {this.photoMarkerIcon(
                imageBgColor,
                editable
              )}
            </div>
            <div style={{
              display: 'flex', flexDirection: 'column', position: 'relative',
              marginBottom: 20,
            }}>
              <label htmlFor='notes'
                className='label-style'
                style={{ marginBottom: 10 }}>Notes:
              </label>
              <textarea name='notes'
                id='notes'
                className='marker-notes'
                onChange={this.onChange.bind(this)}
                value={this.state.notes}
                style={{
                  height: '100px',
                  background: ' #333333 0% 0% no-repeat padding-box',
                  borderRadius: 5,
                  opacity: 1,
                  border: 'none',
                  width: '99%'
                }}
              />
            </div >
            {editable && editable.weatherObservation &&
              <div style={{
                position: 'relative',
                marginBottom: 20
              }}>
                <label htmlFor='notes'
                  className='label-style'
                  style={{ marginBottom: 10 }}>Smart Photo Marker&#8482; Data:
                </label>
                <div className='marker-weather-container'>
                  <div style={{ width: '100%', height: '100%' }}>
                    <div className='weather-data-header' >
                      <p style={{}}>Weather Data</p>
                    </div>
                    <div className='weather-data-value' >
                      <div style={{ display: 'flex' }}>
                        <h1>{`${userPreferences.units == "imperial" ? jsonObject && jsonObject.temparature : Math.round((jsonObject && jsonObject.temparature - 32) / 1.8)}\u00B0`}</h1>
                        <p>{userPreferences.units == "imperial" ? 'F' : 'C'}</p>
                        <img src={jsonObject && jsonObject.iconUrl}
                          style={{ width: jsonObject && jsonObject.iconUrl ? 20 : 0, height: 20, marginLeft: 20 }}
                        ></img>
                        <p style={{ marginLeft: 5, marginTop: 2 }}>{jsonObject && jsonObject.weatherPrimary}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div className='button-container' >
              {
                editable ?
                  <></>
                  :
                  <>
                    {editable && <button style={{
                      width: '40%',
                      margin: '0',
                      backgroundColor: hasCoords ? '#ff6800' : 'grey'
                    }}>Undo</button>}
                  </>
              }
              <button onClick={() => {
                this.handleCancelButton(editable)
              }}
                style={{
                  width: !editable ? '40%' : '40%',
                  margin: '0',
                  marginLeft: !editable ? '10px' : 0,
                  backgroundColor: 'grey'
                }}>Cancel</button>
              <button style={{
                width: !editable ? '40%' : '40%',
                margin: '0',
                marginRight: !editable ? '10px' : 0,
                // backgroundColor: (hasCoords ? '#589500' : 'grey')
                backgroundColor: backgroundColor

              }}
                onClick={this.savePhoto.bind(this)}>Save Changes</button>
            </div>
          </div>
          <div style={{ display: 'none' }}>
            <input type='file'
              accept='image/*'
              onChange={this.setPhoto.bind(this)}
              ref={this.fileInput}></input>
          </div>
          {this.state.confirmRemoval ? <ConfirmRemoval
            remove={this.removePhoto.bind(this)}
            cancel={this.cancelRemoval.bind(this)}
            type='photo' /> : null}


          {this.state.imageViewModel ? <ImageViewModel
            remove={() => { this.setState({ imageViewModel: false }) }}
            ImageUrl={editable ? this.state.imageUrl : this.state.imageFile && URL.createObjectURL(this.state.imageFile)}
            type='photo' /> : null}
          {this.state.discardPopUp ?
            <DiscardChanges cancel={() => this.closePopUp()} discard={() => this.discardChange(editable)} ></DiscardChanges>
            :
            null}
        </>
        }
      </div >
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  mapReference: state.mapReference(),
  photos: state.photos,
  token: state.auth.token,
  user: state.user,
  userPreferences: state.userPreferences,
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  auth: state.auth,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  blockFeatures: () => dispatch(blockFeatures()),
  unBlockFeatures: () => dispatch(unBlockFeatures()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbarAction()),
  photoCreateRequest: photo => dispatch(photoCreateRequest(photo)),
  photoUpdateRequest: photo => dispatch(photoUpdateRequest(photo)),
  photoDeleteRequest: id => dispatch(photoDeleteAction(id)),
  photoUploadRequest: photo => dispatch(photoUploadRequest(photo)),
  weatherUpdate: data => dispatch(weatherUpdate(data)),
  enableMapObject: () => dispatch(enableMapObject()),
  disableMapObject: () => dispatch(disableMapObject())
})

export default connect(mapStateToProps, mapDispatchToProps)(PhotoDetails)